import instance from './requst'
export function getUsername(uesrname) {
    return instance.get('/v1/users/check_username', {
        params: {
            username:uesrname
        }
    })
}
export function getCode(data) {
    return instance.post('/v1/sms/verification_code', data)
}
export function signUp(data){
    return instance.post('/v1/users/signup',data)
}
export function Login(data){
    return instance.post('/v1/users/login',data)
}